export const CONSENT_STORAGE_KEY = 'qonto-marketing-consent';

export function getConsentFromStorage(): boolean {
  try {
    return window.localStorage.getItem(CONSENT_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function hasConsentData(): boolean {
  try {
    return window.localStorage.getItem(CONSENT_STORAGE_KEY) !== null;
  } catch {
    return false;
  }
}

export function setConsent(value: boolean): void {
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, String(value));
  } catch {
    // Silently fail if localStorage is not available
  }
}
